import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core"
import React, { useState } from "react"
import { mergeEquipment } from "../../services/MetadataService"
import EntityAutocomplete from "../EntityAutocomplete"
import { CancelToken } from "axios"

const reload = () => window.location.reload()

const SuccessDialog = ({ open, sourceEquipment, destinationEquipment }) => (
    <Dialog open={open} onClose={reload}>
        <DialogTitle>Equipment Merged</DialogTitle>
        <DialogContent>
            <DialogContentText>
                The points from {sourceEquipment?.name} have been successfully merged
                into {destinationEquipment?.name}. Please reload the page to see the
                changes.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={reload}>Reload Page</Button>
        </DialogActions>
    </Dialog>
)

const MergeEquipmentForm = ({ destinationEquipment }) => {
    
    const [ sourceEquipment, setSourceEquipment ] = useState(null)
    const [ request, setRequest ] = useState({})
    const [ forceReload, setForceReload ] = useState(false)

    if (destinationEquipment == null || destinationEquipment.site == null) 
        return null

    const context = { type: "site", id: destinationEquipment.site.site_id }
    const accept = ["equipment"]
    const readyToMerge = sourceEquipment != null && sourceEquipment.id !== destinationEquipment.id && !request.id

    const onConfirmMerge = () => {
        mergeEquipment(sourceEquipment.id, destinationEquipment.equipment_id, {
            cancelToken: new CancelToken(cancel => {
                setRequest({ id: sourceEquipment.id, cancel })
            })
        }).then(() => {
            setForceReload(true)
        }).catch(err => {
            console.error(err) // TODO: show a proper error to the user
        }).finally(() => {
            setRequest({})
        })
    } 

    return (
        <>
            <SuccessDialog 
                destinationEquipment={destinationEquipment}
                sourceEquipment={sourceEquipment}
                open={forceReload} />
            <div className="merge-equipment equipment-list">
                <div className="section-header">Duplicate Equipment</div>
                <div style={{ padding: '0 1rem' }}>
                    <p>Got duplicate equiment? Use this form to merge it.</p>
                    <Box display="flex" width="100%" alignItems="stretch" alignContent="stretch" style={{ gap: '1rem' }}>
                        <EntityAutocomplete 
                            style={{ flexGrow: 1 }}
                            value={sourceEquipment}
                            disabled={request.id != null}
                            onEntitySelected={setSourceEquipment}
                            input={{ 
                                label: `${destinationEquipment.site.name} Equipment`,
                                disabled: request.id != null
                            }} 
                            context={context} 
                            accept={accept} />
                        <Button 
                            disabled={!readyToMerge}
                            variant="contained" 
                            color="primary"
                            onClick={onConfirmMerge}>
                                { request.id ? "MERGING" : "MERGE" }
                                { request.id ? <>&nbsp;&nbsp;<CircularProgress color="inherit" size="1rem" /></> : null }
                        </Button>
                    </Box>
                </div>
            </div>
        </>
    )
}

export default MergeEquipmentForm;
